




















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('ubic', [
      'token'
    ]),
  },
})
export default class Attachments extends Vue {
  @Prop() read_only!: boolean;
  @Prop() attachments!: any;
  @Prop() throw_data!: any;
  @Prop({ type: Function }) removeFile!: Function;
  @Prop({ type: Function }) addAttachments!: Function;
  dropFiles: any = [];
  token!: any;
  loading: boolean = false
  loaded: boolean = false

  content: any[] = []
  
  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  removeFileAction($event: any) {
    this.removeFile($event, this.throw_data)
  }

  @Watch('attachments')
  onAttachmentsChange() {
    this.setContent()
  }

  public mounted() {
    this.setContent()
  }

  public setContent() {
    this.loaded = false;
    this.loading = true;
    this.content = [];

    if (this.attachments) {
      this.attachments.map((file: any) => {
        const url = this.FILES_HOST + '/api/v1/files/download_preview/' + file.id + '?authorization=' + this.token
        const request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'blob';
        request.onload = () => {
            const reader = new FileReader();
            reader.readAsDataURL(request.response);
            reader.onload = (e: any) => {
              const mime = e.target.result.split(';')[0].split(':')[1].split('/')[0];
              console.log(mime)
              this.content.push({data: e.target.result, mime: mime})
            };
        };
        request.send();
      })
    }
    this.loaded = true;
    this.loading = false;
  }
  
  public downloadFile(base64URL: string){
    const win = window.open();
    // @ts-ignore
    (win.document as any).write('<iframe src="' + base64URL  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
}

  uploadFileAction(files: File[]) {
    for (const file of files) {
      const formData = new FormData();

      formData.append('file', file);

      // @ts-ignore
      this.$http.post(`/api/v1/files`,
        formData, {
        }
      ).then((response: any) => {
        this.addAttachments(response.data.file, this.throw_data);
      })
    }
    this.dropFiles = []
  }
}
